import axios from 'axios'
import source from '@/store/modules/source'
import authen from '@/store/modules/authen'

const instanceApi = (authentication = true) =>{

    console.log(process.env.VUE_APP_API);
    
    const http = axios.create({ baseURL: process.env.VUE_APP_API });
    http.defaults.headers.common['Content-Type'] = 'application/json';
    http.defaults.headers.common['SML-Server'] = source.state.apiUrl;
    http.defaults.headers.common['SML-Provider'] = source.state.provider;
    http.defaults.headers.common['SML-Database'] = source.state.database;
    if(authentication){
        http.defaults.headers.common['Authorization'] = authen.state.token;
        console.log('token_', authen.state.token);        
    }
    return http;
}

export default {
    instanceApi
}

export {
    instanceApi
}
